<template>
  <div class="content-wrapper solutions">
    <v-img width="100%" aspect-ratio="4.16" src="images/solutions.jpg" alt="" />

    <div class="b-solutions">
      <div
        v-for="(solution, index) in solutions"
        :key="index"
        class="b-solution"
      >
        <router-link :to="{ name: solution.routeName }">
          <div class="b-solution-title">{{ solution.title }}</div>
          <div class="b-solution-img">
            <v-img
              :src="solution.img"
              :alt="solution.title"
              :aspect-ratio="1.658"
            />
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      solutions: [
        {
          title: "Влажные помещения",
          img: "upload/iblock/71b/71b61e65132584776631e052b527cc6c.jpg",
          routeName: "vlazhnye",
        },
        {
          title: "Жилые помещения",
          img: "upload/iblock/08f/08f3621b880673100bf7e709e0da8fbd.jpg",
          routeName: "zhilye",
        },
        {
          title: "Балконы и террасы",
          img: "upload/iblock/8a0/8a01e6600b83ee4260a82cfed93004ad.jpg",
          routeName: "balkony",
        },
        {
          title: "Гараж",
          img: "upload/iblock/f02/f02f30d224853a45d439ba78e0a6a252.jpg",
          routeName: "garage",
        },
        {
          title: "Кухня",
          img: "upload/iblock/9c1/9c1bc0b7bdbc0f69ccb4a4e85942efb2.jpg",
          routeName: "kukhnya",
        },
        {
          title: "Подвал",
          img: "upload/iblock/981/9818ca7d995864e8c835f73ab3be8e80.jpg",
          routeName: "podval",
        },
        {
          title: "Фасад",
          img: "upload/iblock/609/609fa9b99c7d38d7e8de261e3396704e.jpg",
          routeName: "fasad",
        },
      ],
    };
  },
};
</script>

<style lang="scss"></style>
